import { Layout } from 'components/layout';
import React from 'react';
import { Router } from '@reach/router';
import { DestinationPage } from 'modules/destinations';
import { DestinationItem } from 'modules/destinations/destination-details/DestinationItem';
import { useIntl } from 'gatsby-plugin-react-intl';
import { usePrismicDocuments } from 'hooks';
import { PROJECT_DISTRAP_UID } from 'modules/project-distrap';

const Destinations: React.FC = () => {
  const { locale } = useIntl();
  const documents = usePrismicDocuments(locale, 'destination');
  const listedDocuments = documents?.filter(
    (item) => item.node._meta.uid !== PROJECT_DISTRAP_UID,
  );

  return (
    <Layout isGhostNav={false}>
      <Router>
        <DestinationPage
          path={`/${locale}/destinations/`}
          documents={listedDocuments}
        />
        <DestinationItem
          path={`/${locale}/destinations/:uid`}
          documents={documents}
        />
      </Router>
    </Layout>
  );
};

export default Destinations;
